/* eslint-disable */
import React, { useCallback, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { getSessionList, getupdateSessionDetail } from "store/sessionListSlice";
import { selectUser } from "store/authSlice";
import EscapeIcon from "components/nav-components/nav-icons/escape-icon";
import Button from "components/common/button/button";
import {
  checkSessionDataStatus,
  discardSessionAPI,
  getJumpDataAPI,
  getRunDataAPI,
  reRunMetricsAPI,
} from "../../api/session";
import { getSessionFromList, msToTime } from "../../utils/helper";
import * as metricRules from "../../utils/metrics";
import { UserProfile_URL } from "../../utils/urls";
import CadenceReport from "../metrics/CadenceReport";
import ContactTimeJump from "../metrics/ContactTimeJump";
import FlightTime from "../metrics/FlightTime";
import FlightTimeJump from "../metrics/FlightTimeJump";
import Force from "../metrics/ForceData";
import GroundContactTime from "../metrics/GroundContactTime";
import JumpHeight from "../metrics/JumpHeight";
import PeakTibialAcceleration from "../metrics/PeakTibialAccelerationReport";
import Power from "../metrics/Power";
import RSI from "../metrics/RSI";
import FlightTimeAsymmetry from "components/metrics/FlightTimeAsymmetry";
import GroundContactTimeAsymmetry from "components/metrics/GroundContactTimeAsymmetry";
import SwingStanceFootStrike from "components/metrics/SwingStanceFootStrike";
import Video from "../metrics/Video";
import "../../styles/metrics_updated.scss";
import { useState } from "react";
import { useEffect } from "react";
import ReportsDownloadModal from "components/common/downloadModal/reportsDownloadModal";
import TestSlide from "components/common/testSlide/testSlide";
import PictureMaps from "components/metrics/PictureMaps";
import { displayDateForPlayerList } from "../../utils/helper";
import DriveIndex from "components/metrics/DriveIndex";
import MetricBrush from "components/metrics/metric-helpers/MetricBrush";
import MetricTrimBrush from "components/metrics/metric-helpers/MetricTrimBrush";
import TrimIcon from "components/common/icons/trimIcon";
import { useCheckForJumpData } from "components/common/hooks/useCheckForJumpData";
import { setGraphModal, setSelectedSessionId } from "store/playerActivitySlice";
import { getJumpData, resetJumpData } from "store/jumpDataSlice";
import { getRunData, resetRunData } from "store/runDataSlice";
import { setSessionTrim, resetSessionTrim } from "api/charts";
import MagnifyingGlass from "components/common/icons/magnifyingGlass";
import SessionTaggingModal from "components/common/taggingModal/SessionTaggingModal";
import { resetAllData } from "store/sessionSlice";
import AlertDialogDemo from "components/common/alertDialog/alertDialog";
import EditIcon from "components/common/icons/editIcon";
import ActivityChangeModal from "components/common/activityChangeModal/ActivityChangeModal";
import GroundClearance from "components/metrics/GroundClearance";
import GroundClearanceAsymmetry from "components/metrics/GroundClearanceAsymmetry";
import StepLength from "components/metrics/StepLength";
import StepLengthAsymmetry from "components/metrics/StepLengthAsymmetry";
import StrideVelocity from "components/metrics/StrideVelocity";
import StrideVelocityAsymmetry from "components/metrics/StrideVelocityAsymmetry";
import GroundClearanceJump from "components/metrics/GroundClearanceJump";
import JumpLength from "components/metrics/JumpLength";
import JumpVelocity from "components/metrics/JumpVelocity";
import StrideTime from "components/metrics/StrideTime";
import StrideTimeAsymmetry from "components/metrics/StrideTimeAsymmetry";
import SwingTime from "components/metrics/SwingTime";
import SwingTimeAsymmetry from "components/metrics/SwingTimeAsymmetry";
import MainModal from "components/common/mainModal/MainModal";
import MainButton from "components/common/reuseableButtonComponent/MainButton";
import DeleteIcon from "components/common/icons/deleteIcon";
import ResetIcon from "components/common/icons/reset";
import WarningTooltip from "components/common/warningTooltip/WarningTooltip";
import { userState } from "store/authSlice";
import { updateUserLayoutAPI } from "api/user";
import Spinner from "components/common/spinner/spinner";
import MainTooltip from "components/common/mainTooltip/MainTooltip";
import StrideLength from "components/metrics/StrideLength";
import StrideLengthAsymmetry from "components/metrics/StrideLengthAsymmetry";
import * as metricDescriptions from "../../components/metricDescriptionsJson/metricDescription.json";
import RawChartComponent from "components/metrics/RawChartComponent";
import SessionSummary from "components/metrics/SessionSummary";
import PlayerActivityHeader from "./playerActivityHeader/PlayerActivityHeader";
import { selectOrganisation } from "store/orgSlice";
import {
  getTeamsAthletes,
  resetTeamAthletesData,
} from "store/teamsAthletesSlice";
import { getTeams } from "store/teamSlice";
import { getTeamGroups, resetTeamGroupData } from "store/groupSlice";
import DownloadIcon from "components/common/icons/downloadIcon";
import TagsIcon from "components/common/icons/tags";
import SessionSettingsModalBody from "./playerActivitySettingsModal/SessionSettingsModalBody";
import {
  thisUserIsACoachOfThisOrg,
  thisUserIsAnAdminOfThisOrg,
} from "utils/userHelper";
import Settings from "components/common/icons/settings";
import { Responsive, WidthProvider } from "react-grid-layout";
import CloseIcon from "components/common/icons/closeIcon";
import ActivityScore from "components/metrics/ActivityScore";

const ResponsiveGridLayout = WidthProvider(Responsive);

function PlayerActivityDetails(props) {
  //declaring state
  const [textareaValue, settextareaValue] = useState("");
  const [editForm, setEditForm] = useState(false);
  const [rerunMetricButton, setRerunMetricButton] = useState("Rerun Metrics");
  const [graphDomain, setGraphDomain] = useState(false);
  const [graphTrimDomain, setGraphTrimDomain] = useState(["auto", "auto"]);
  const [domainToggle, setDomainToggle] = useState(false);
  const [trimToggle, setTrimToggle] = useState(false);
  const [isTrimOpen, setIsTrimOpen] = useState(false);
  const [tagBeingAdded, setTagBeingAdded] = useState(false);
  const [discardSessionModalOpen, setDiscardSessionModalOpen] = useState(false);
  const [strideVelocityDisplayed, setStrideVelocityDisplayed] =
    useState("meanStrideVelocity");
  const [jumpVelocityDisplayed, setJumpVelocityDisplayed] =
    useState("meanJumpVelocity");
  const [cadenceFrequencyToggler, setCadenceFrequencyToggler] =
    useState("cadenceData");
  const [sessionMetricsToggled, setSessionMetricsToggled] = useState([]);
  const [disabledGraphIDs, setDisabledGraphIDs] = useState([]);

  //metric summaries
  const [toggledSummaryIDs, setToggledSummaryIDs] = useState({
    toggledKpiSummaryIDs: [],
    toggledAsymmetrySummaryIDs: [],
  });
  const [disabledSummaryIDs, setDisabledSummaryIDs] = useState({
    disabledKpiSummaryIDs: [],
    disabledAsymmetrySummaryIDs: [],
  });

  const dispatch = useDispatch();

  //teams
  const [teamsInOrg, setTeamsInOrg] = useState([]);
  const [groupsInTeams, setGroupsInTeams] = useState([]);
  const [athletesInTeams, setAthletesInTeams] = useState([]);

  const { status, teams } = useSelector((state) => state.team);
  const { groupStatus, groups } = useSelector((state) => state.group);
  const { teamAthletesStatus, teamsAthletes } = useSelector(
    (state) => state.teamAthlete
  );

  //free run selectedSession
  const [selectedActivityType, setSelectedActivityType] = useState(null);

  //session loading
  const [sessionLoading, setSessionLoading] = useState(true);

  const { playerActivity, session, sessionList, activityList } = useSelector(
    (state) => ({
      activityList: state.activity,
      session: state.sessionList,
      playerActivity: state.playerActivity,
      sessionList: state.session,
    })
  );

  const [isClosing, setIsClosing] = useState(false);

  // tab selected
  const [tabSelected, setTabSelected] = useState(0);

  //logged userData
  const loggedUserData = useSelector(userState);

  //props declared
  const { actions, organisation, user } = props;
  let xAxisDomainConcatArray = [];
  let yAxisDomainConcatArray = [];
  let asymRangeArray = [];
  let asymRangeArray_y = [];
  let asymJumpRangeArray = [];

  const checkForJumpData = useCheckForJumpData();
  const selectedSessionId = playerActivity.selectedSessionId;
  const graphModal = playerActivity.graphModal;

  let updatedData;

  let thisSession;

  if (session?.sessionList?.data) {
    thisSession = getSessionFromList(
      selectedSessionId,
      session.sessionList?.data
    );
  }

  // immediate invocation of function, checks if session is trimmed and applies trim to the set domain
  (() => {
    if (
      thisSession?.ActivityType === "Run" &&
      sessionList.runData.data &&
      sessionList.runData.data?.td &&
      sessionList.runData.data?.td.length > 0 &&
      session.status === "succeeded" &&
      playerActivity.graphModal
    ) {
      let domainStart = sessionList?.runData?.data?.td[0].from / 1000;
      let domainEnd = sessionList?.runData?.data?.td[0].to / 1000;
      if (
        sessionList?.runData?.data?.td.length > 0 &&
        String(graphDomain) !== String([domainStart, domainEnd])
      ) {
        if (graphDomain === false && graphTrimDomain[0] === "auto") {
          setGraphDomain([domainStart, domainEnd]);
          setGraphTrimDomain([domainStart, domainEnd]);
          // checkForJumpData();
        }
      }
    }

    if (
      thisSession?.ActivityType === "Jump" &&
      sessionList.jumpData.data &&
      sessionList.jumpData.data?.td &&
      sessionList.jumpData.data?.td.length > 0 &&
      session.status === "succeeded" &&
      playerActivity.graphModal
    ) {
      let domainStart = sessionList?.jumpData?.data?.td[0].from / 1000;
      let domainEnd = sessionList?.jumpData?.data?.td[0].to / 1000;
      if (
        sessionList?.jumpData?.data?.td.length > 0 &&
        String(graphDomain) !== String([domainStart, domainEnd])
      ) {
        if (graphDomain === false && graphTrimDomain[0] === "auto") {
          setGraphDomain([domainStart, domainEnd]);
          setGraphTrimDomain([domainStart, domainEnd]);
          // checkForJumpData();
        }
      }
    }
  })();
  // look at adding a loading state when loading charts, small visual bug occurs when loading if a disabled chart layout is saved.

  useEffect(() => {
    const fetchData = () => {
      if (status === "idle" || teams?.length === 0) {
        dispatch(getTeams());
      }
    };
    fetchData();
  }, [thisSession?.orgID]);

  useEffect(() => {
    if (teams?.length !== 0) {
      const orgTeams = teams?.filter(
        (item) => item.orgid === thisSession?.orgID
      );
      setTeamsInOrg(orgTeams);
    }
  }, [organisation, teams, thisSession?.orgID]);

  useEffect(() => {
    teamsInOrg.forEach((team) => {
      const fetchData = () => {
        if (groupStatus == "idle" && groups.length === 0) {
          dispatch(getTeamGroups(team.id));
        }
        if (teamAthletesStatus == "idle" && teamsAthletes.length === 0) {
          dispatch(getTeamsAthletes(team.id));
        }
      };
      fetchData();
    });
  }, [teamsInOrg, thisSession?.orgID]);

  useEffect(() => {
    setGroupsInTeams(groups);

    setAthletesInTeams(teamsAthletes);
  }, [groups, teamsAthletes, thisSession?.orgID]);

  useEffect(() => {
    if (sessionLoading === true && playerActivity.graphModal === true) {
      setTimeout(() => {
        setSessionLoading(false);
      }, 2500);
    }
  }, [playerActivity.graphModal === true, playerActivity.selectedSessionId]);

  useEffect(() => {
    let savedLayoutUserData =
      loggedUserData?.user?.layout && JSON.parse(loggedUserData?.user?.layout);
    if (localStorage.getItem("userLayout")) {
      savedLayoutUserData = JSON.parse(localStorage.getItem("userLayout"));
    }
    if (
      savedLayoutUserData?.sessionLayout?.[
        thisSession?.ActivityName?.toLowerCase()
      ]?.disabledGraphIDs?.length > 0 &&
      playerActivity.graphModal === true
    ) {
      setTimeout(() => {
        setDisabledGraphIDs(
          savedLayoutUserData?.sessionLayout?.[
            thisSession?.ActivityName?.toLowerCase()
          ]?.disabledGraphIDs
        );
      }, 2000);
    }
    if (
      (savedLayoutUserData?.sessionLayout?.[
        thisSession?.ActivityName?.toLowerCase()
      ]?.disabledSummaryIDs?.disabledKpiSummaryIDs?.length > 0 ||
        savedLayoutUserData?.sessionLayout?.[
          thisSession?.ActivityName?.toLowerCase()
        ]?.disabledSummaryIDs?.disabledAsymmetrySummaryIDs?.length > 0) &&
      playerActivity.graphModal === true
    ) {
      setTimeout(() => {
        setDisabledSummaryIDs({
          disabledKpiSummaryIDs:
            savedLayoutUserData?.sessionLayout?.[
              thisSession?.ActivityName?.toLowerCase()
            ]?.disabledSummaryIDs?.disabledKpiSummaryIDs,
          disabledAsymmetrySummaryIDs:
            savedLayoutUserData?.sessionLayout?.[
              thisSession?.ActivityName?.toLowerCase()
            ]?.disabledSummaryIDs?.disabledAsymmetrySummaryIDs,
        });
      }, 2000);
    }
  }, [playerActivity.graphModal === true]);

  useEffect(() => {
    if (tagBeingAdded === true) {
      checkForJumpData();
      dispatch(getSessionList());
    }
    setTagBeingAdded(false);
  }, [tagBeingAdded]);

  const storedLayout = JSON.parse(localStorage.getItem("userLayout"));

  const [customGridLayout, setCustomGridLayout] = useState(
    storedLayout?.sessionLayout?.[thisSession?.ActivityName?.toLowerCase()]
      ?.gridLayout || []
  );

  const [initialLayoutSet, setInitialLayoutSet] = useState(false);

  useEffect(() => {
    const newLayout =
      storedLayout?.sessionLayout?.[thisSession?.ActivityName?.toLowerCase()]
        ?.gridLayout || [];

    // Ensure newLayout has value and only set it once
    if (!initialLayoutSet && newLayout.length > 0) {
      if (JSON.stringify(newLayout) !== JSON.stringify(customGridLayout)) {
        setCustomGridLayout(newLayout);
        setInitialLayoutSet(true); // Mark as set
      }
    }
  }, [storedLayout, thisSession]); // Dependencies won't cause it to reset

  const containerRef = useRef(null);

  function scrollToTop(divId) {
    const div = document.getElementById(divId);
    if (div) {
      div.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  //close modal handler
  function closeModal() {
    dispatch(setGraphModal(!playerActivity.graphModal));
    dispatch(setSelectedSessionId(null));
    document.body.classList.remove("disableScroll");
    setRerunMetricButton("Rerun Metrics");
    setDisabledGraphIDs([]);
    setCustomGridLayout([]);
    setInitialLayoutSet(false);
    setSelectedActivityType(null);
    setTabSelected(0);
  }

  useEffect(() => {
    setTrimToggle(!trimToggle);
    function disableScrollModalOpen() {
      document.body.classList.add("disableScroll");
    }

    function enableScrollModalClosed() {
      document.body.classList.remove("disableScroll");
    }
    setTimeout(() => {
      if (playerActivity.graphModal) {
        disableScrollModalOpen();
        setGraphDomain(false);
        setGraphTrimDomain(["auto", "auto"]);
        setTrimToggle(!trimToggle);
      } else {
        enableScrollModalClosed();
      }
    }, 500);

    // Cleanup function
    return () => {
      if (playerActivity.graphModal && playerActivity.selectedSessionId) {
        dispatch(setSelectedSessionId(null));
        dispatch(setGraphModal(!playerActivity.graphModal));
      }

      enableScrollModalClosed();
    };
  }, [playerActivity.graphModal, playerActivity.selectedSessionId]);

  //has data succeded
  const getSucceededData = (obj) => {
    // Loop through each key in the object
    for (let key in obj) {
      // Check if the current key's object has loaded as true and status as succeeded
      if (obj[key].loaded === true && obj[key].status === "succeeded") {
        // Return the data for the matched condition
        return obj[key].data;
      }
    }
    // Return null if no object matches the condition
    return null;
  };

  //user layout variables
  const customGridLayoutRef = useRef([]);

  const handleLayoutChange = useCallback(
    (newLayout) => {
      // Only update ref if layout actually changes
      if (
        JSON.stringify(customGridLayoutRef.current) !==
        JSON.stringify(newLayout)
      ) {
        customGridLayoutRef.current = newLayout;

        //maybe add local storage in here
      }
    },
    [thisSession?.ID]
  );

  useEffect(() => {
    if (!customGridLayout.length) {
      setCustomGridLayout(customGridLayoutRef.current);
    }
  }, [thisSession?.ID, customGridLayoutRef.current]);

  //get items within specific div
  function getGraphsRenedered() {
    let elements = document
      ?.querySelector(".metric-list-container")
      ?.querySelectorAll(".toggle-metric-class");
    let dynamicElements = document
      ?.querySelector(".raw_metrics_container")
      ?.querySelectorAll(".toggle-metric-class");
    let elementsIDs = [];

    for (let i = 0; i < elements?.length; i++) {
      elementsIDs?.push(elements[i].id);
    }
    for (let i = 0; i < dynamicElements?.length; i++) {
      elementsIDs?.push(dynamicElements[i].id);
    }

    setSessionMetricsToggled(elementsIDs);
  }

  function getSummariesRendered() {
    let kpiElements = document
      ?.querySelector(".metric-list-container")
      ?.querySelectorAll(".kpi_card");
    let asymmElements = document
      ?.querySelector(".metric-list-container")
      ?.querySelectorAll(".symm_card");

    let kpiElementsIDs = [];
    let asymmElementsIDs = [];

    for (let i = 0; i < kpiElements?.length; i++) {
      kpiElementsIDs?.push(kpiElements[i].id);
    }

    for (let i = 0; i < asymmElements?.length; i++) {
      asymmElementsIDs?.push(asymmElements[i].id);
    }

    setToggledSummaryIDs({
      toggledKpiSummaryIDs: kpiElementsIDs,
      toggledAsymmetrySummaryIDs: asymmElementsIDs,
    });
  }

  //user session layout ------!!!!!!!!!!!!!!!!!!!!!!!!!!

  async function updateSessionLayout() {
    const activityType = await thisSession?.ActivityName.toLowerCase();
    const localStorageData = JSON.parse(localStorage.getItem("userLayout"));

    const postBody = {
      layout: JSON.stringify({
        pdf: { ...localStorageData.pdf },
        comparison: { ...localStorageData.comparison },
        sessionLayout: {
          ...localStorageData.sessionLayout,
          [activityType]: {
            disabledGraphIDs: disabledGraphIDs,
            disabledSummaryIDs: disabledSummaryIDs,
            gridLayout: gridLayout,
          },
        },
        athleteOverview: { ...localStorageData.athleteOverview },
        theme: { ...localStorageData.theme },
      }),
    };
    localStorage.setItem("userLayout", postBody.layout);
    await updateUserLayoutAPI(postBody);
  }

  //scroll to top when modal rerenders
  function scrollToTop() {
    if (document.getElementById("modal-activity-box"))
      document.getElementById("modal-activity-box").scrollTop = 0;
  }

  function displaySessionDetail(thisSession) {
    const { name, detail, playerName } = thisSession;

    if (detail && detail !== "Add Description" && detail !== "") {
      if (name && name !== "Add Description" && name !== "") {
        if (name.includes(playerName)) {
          return detail;
        } else {
          return `${detail}, ${name}`;
        }
      } else if (name !== playerName) {
        return detail;
      }
    } else if (
      name &&
      name !== "Add Description" &&
      name !== "" &&
      name !== playerName
    ) {
      return name;
    }

    return "-";
  }

  const handleDiscardSessionModal = () => {
    setDiscardSessionModalOpen(true);
    document.body.classList.add("modal-open");
  };

  function discardSession(e) {
    e.preventDefault();

    discardSessionAPI(selectedSessionId).then(() => {
      setDiscardSessionModalOpen(false);
      closeModal();
      // dispatch(getSessionList())
      if (typeof props?.removeSessionFromList === "function") {
        props.removeSessionFromList(selectedSessionId);
      } else {
      }
    });

    document.body.classList.remove("modal-open");
  }

  //rerun metrics
  function rerunMetrics() {
    setRerunMetricButton("Re-running Metrics");

    reRunMetricsAPI(selectedSessionId).then(() => {
      let thisSession;
      if (session.sessionList) {
        thisSession = session.sessionList?.data.find(
          (s) => s.ID === selectedSessionId
        );
      }

      if (!thisSession) {
        return;
      }

      if (
        thisSession &&
        (thisSession.jumpTypeID > 0 ||
          thisSession.activityTypeID === 2 ||
          thisSession.activityID === 52)
      ) {
        actions.resetJumpData(thisSession.ID);

        let numRequestsMade = 0;
        const interval = setInterval(() => {
          checkSessionDataStatus(thisSession.ID).then((res) => {
            numRequestsMade++;
            if (res.offlineJobStatus === 2 || numRequestsMade >= 8) {
              clearInterval(interval); // Clear the interval
              setRerunMetricButton("Rerun Metrics");
              if (res.offlineJobStatus === 2) {
                dispatch(setSelectedSessionId(selectedSessionId));
                setTimeout(() => {
                  checkForJumpData();
                }, 2000);
              }
            }
          });
        }, 3000);
      } else if (
        thisSession.runTypeID > 0 ||
        thisSession.activityTypeID === 1 ||
        thisSession.activityID === 21
      ) {
        //for other - call rundata API as capacitance will be returned here

        actions.resetRunData(thisSession.ID); // sets to loading

        let numRequestsMade = 0;
        const interval = setInterval(() => {
          checkSessionDataStatus(thisSession.ID).then((res) => {
            numRequestsMade++;
            if (res.offlineJobStatus === 2 || numRequestsMade >= 8) {
              clearInterval(interval); // Clear the interval
              setRerunMetricButton("Rerun Metrics");

              if (res.offlineJobStatus === 2) {
                dispatch(setSelectedSessionId(selectedSessionId));
                setTimeout(() => {
                  checkForJumpData();
                }, 2000);
              }
            }
          });
        }, 3000);
      }
    });
  }

  //if modal is open disable body scroll
  function disableScrollModalOpen() {
    document.body.classList.add("disableScroll");
  }

  function enableScrollModalClosed() {
    document.body.classList.remove("disableScroll");
  }

  if (playerActivity.graphModal) {
    disableScrollModalOpen();
  }

  //takes in a array and decides the x axis max value of the grahphs based on max values
  function chartXdomainScale(arr) {
    let newArr = arr.map((item) =>
      item.Symmetry < 0 ? item.Symmetry * -1 : item.Symmetry
    );

    //custom range
    // return([-1*(Math.max(...newArr))-10, Math.max(...newArr)+10])

    return Math.max(...newArr) < 50 ? [-50, 50] : [-100, 100];
  }

  function chartYdomainScale(arr) {
    //creates array of from specific object keys
    let newArr = arr.map(
      (item) => Number(item["Left Foot"]) || Number(item["Right Foot"])
    );
    //filteres out NaN values
    //const newArr2 = newArr.filter(item => item !== NaN ? item : "");
    newArr = newArr.filter((item) => !isNaN(item));
    //sets the range from 0 - the max value of the array fixed to two devimal places and turned to number
    return [
      0,
      Number(
        (Math.max(...newArr) + (Math.max(...newArr) / 100) * 10).toFixed(2)
      ),
    ];
  }

  const strideSymmetryData = sessionList?.runData?.data?.StrideSymmetryData;

  if (strideSymmetryData && strideSymmetryData.length !== 0) {
    const contactTime = strideSymmetryData.contactTime;
    const flightTime = strideSymmetryData.flightTime;
    const meanStrideVelocity = strideSymmetryData.meanStrideVelocity;
    const maxStrideVelocity = strideSymmetryData.maxStrideVelocity;
    const stepLength = strideSymmetryData.stepLength;
    const groundClearance = strideSymmetryData.groundClearance;

    if (
      contactTime &&
      contactTime.length !== 0 &&
      flightTime &&
      flightTime.length !== 0 &&
      meanStrideVelocity &&
      meanStrideVelocity.length !== 0 &&
      maxStrideVelocity &&
      maxStrideVelocity.length !== 0 &&
      stepLength &&
      stepLength.length !== 0 &&
      groundClearance &&
      groundClearance.length !== 0
    ) {
      // Spreads the two arrays into one
      xAxisDomainConcatArray = [
        ...contactTime,
        ...flightTime,
        ...meanStrideVelocity,
        ...maxStrideVelocity,
        ...stepLength,
        ...groundClearance,
      ];

      // Sets the value of range array to the result of the chart function by passing the concat array as a parameter
      asymRangeArray = chartXdomainScale(xAxisDomainConcatArray);
    } else if (
      contactTime &&
      contactTime.length !== 0 &&
      flightTime &&
      flightTime.length !== 0
    ) {
      // Spreads the two arrays into one
      xAxisDomainConcatArray = [...contactTime, ...flightTime];

      // Sets the value of range array to the result of the chart function by passing the concat array as a parameter
      asymRangeArray = chartXdomainScale(xAxisDomainConcatArray);
    }
  }

  const jumpData = sessionList.jumpData?.data;
  if (jumpData) {
    const jumpSymmetryChartData = jumpData.jumpData?.symmetryChartData;
    const flightSymmetryChartData = jumpData.flightData?.symmetryChartData;
    const powerSymmetryChartData = jumpData.powerData?.symmetryChartData;
    const rsiSymmetryChartData = jumpData.rsiData?.symmetryChartData;
    const contactTimeSymmetryChartData =
      jumpData.contactTimeData?.symmetryChartData;

    if (
      jumpSymmetryChartData &&
      flightSymmetryChartData &&
      powerSymmetryChartData
    ) {
      xAxisDomainConcatArray = [
        ...jumpSymmetryChartData,
        ...flightSymmetryChartData,
        ...powerSymmetryChartData,
      ];
      asymJumpRangeArray = chartXdomainScale(xAxisDomainConcatArray);
    }
    if (
      rsiSymmetryChartData &&
      flightSymmetryChartData &&
      contactTimeSymmetryChartData
    ) {
      xAxisDomainConcatArray = [
        ...rsiSymmetryChartData,
        ...flightSymmetryChartData,
        ...contactTimeSymmetryChartData,
      ];
      asymJumpRangeArray = chartXdomainScale(xAxisDomainConcatArray);
    }
  }

  const runData = sessionList?.runData?.data;
  if (runData?.length) {
    const flightTimeData = runData?.FlightTimeData;
    const contactTimeData = runData?.ContactTimeData;

    if (
      flightTimeData &&
      flightTimeData.length !== 0 &&
      contactTimeData &&
      contactTimeData.length !== 0
    ) {
      yAxisDomainConcatArray = [
        ...flightTimeData?.stepData,
        ...contactTimeData?.stepData,
      ];
      asymRangeArray_y = chartYdomainScale(yAxisDomainConcatArray);
    }
  }

  const handleBrushResize = () => {
    if (
      !document
        .querySelector(".metric-brush-container-closed")
        .classList.contains("metric-brush-container-open")
    ) {
      document
        .querySelector(".metric-brush-container-closed")
        .classList.add("metric-brush-container-open");
    } else {
      document
        .querySelector(".metric-brush-container-closed")
        .classList.remove("metric-brush-container-open");
    }
  };

  const handleBrushTrim = () => {
    if (
      !document
        .querySelector(".metric-trim-brush-container-closed")
        .classList.contains("metric-trim-brush-container-open")
    ) {
      document
        .querySelector(".metric-trim-brush-container-closed")
        .classList.add("metric-trim-brush-container-open");
      setIsTrimOpen(true);
    } else {
      document
        .querySelector(".metric-trim-brush-container-closed")
        .classList.remove("metric-trim-brush-container-open");
      setIsTrimOpen(false);
    }
  };

  const activity = activityList.activities.filter(
    (item) => item?.id === thisSession?.activityID
  );

  function renderCapacitanceOnly(selectedSession, sessionData, dataType) {
    //graph type should be either capacitance or other

    const activityDataKey =
      selectedSession.ActivityType === "Run" ? "runData" : "jumpData";

    if (dataType === "capacitance") {
      return true;
    } else if (
      dataType === "other" &&
      activityDataKey === "runData" &&
      Object.keys(sessionData?.[activityDataKey]?.data || {}).length &&
      Object.keys(sessionData?.[activityDataKey]?.data.ContactTimeData || {})
        .length > 0 &&
      Object.keys(sessionData?.[activityDataKey]?.data.FootstrikeData || {})
        .length > 0 &&
      Object.keys(
        sessionData?.[activityDataKey]?.data.PeakTibialAccelerationData || {}
      ).length > 0 &&
      Object.keys(sessionData?.[activityDataKey]?.data.StrideSymmetryData || {})
        .length > 0 &&
      Object.keys(sessionData?.[activityDataKey]?.data.SwingStanceData || {})
        .length > 0 &&
      Object.keys(sessionData?.[activityDataKey]?.data.cadenceData || {})
        .length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  const activityKeys = [
    { id: 1, name: "Sprint", color: "rgba(227, 181, 5,1.0)" },
    { id: 2, name: "Jog", color: "rgba(36, 123, 160,1.0)" },
    { id: 3, name: "Walk", color: "rgba(89, 205, 144,1.0)" },
    {
      id: 4,
      name: "Double Leg Countermovement jump",
      color: "rgba(217, 3, 104,1.0)",
    },
    { id: 5, name: "Double Leg Drop Jump", color: "rgba(242, 158, 76,1.0)" },
    { id: 9, name: "Double Leg Squat Jump", color: "rgba(115, 113, 252,1.0)" },
    {
      id: 10,
      name: "Double Leg Repeated Hops",
      color: "rgba(110, 250, 251,1.0)",
    },
    { id: 11, name: "Double Leg Depth Jump", color: "rgba(194, 232, 18,1.0)" },
    {
      id: 12,
      name: "Double Leg Horizontal Jump",
      color: "rgba(3, 109, 25,1.0)",
    },
    {
      id: 14,
      name: "Single Leg Countermovement Jump",
      color: "rgba(58, 134, 255,1.0)",
    },
    { id: 15, name: "Single Leg Squat Jump", color: "rgba(41, 128, 185,1.0)" },
    { id: 16, name: "Single Leg Drop Jump", color: "rgba(242, 227, 188,1.0)" },
    {
      id: 17,
      name: "Single Leg Repeated Hops",
      color: "rgba(233, 210, 244,1.0)",
    },
    { id: 18, name: "Single Leg Depth Jump", color: "rgba(70, 18, 32,1.0)" },
    { id: 21, name: "Other", color: "rgba(255, 190, 118,1.0)" },
    { id: 22, name: "Isometric Calf Test ", color: "rgba(255, 190, 118,1.0)" },
    { id: 35, name: "Bench press", color: "rgba(255, 190, 118,1.0)" },
    { id: 36, name: "Pull-up", color: "rgba(255, 190, 118,1.0)" },
    { id: 37, name: "Military press", color: "rgba(255, 190, 118,1.0)" },
    { id: 38, name: "Squat", color: "rgba(255, 190, 118,1.0)" },
    { id: 39, name: "Deadlift", color: "rgba(255, 190, 118,1.0)" },
    { id: 40, name: "Leg-press", color: "rgba(255, 190, 118,1.0)" },
    { id: 41, name: "Quiet Stance", color: "rgba(255, 77, 77,1.0)" },
    { id: 42, name: "Single Leg Stance", color: "rgba(253, 114, 114,1.0)" },
    { id: 43, name: "Agility", color: "rgba(164, 74, 63,1.0)" },
    { id: 44, name: "Free Run", color: "rgba(255, 190, 118,1.0)" },
    { id: 45, name: "Free-Living Analysis", color: "rgba(255, 190, 118,1.0)" },
    { id: 46, name: "Multi-Activity", color: "rgba(255, 190, 118,1.0)" },
    { id: 48, name: "Timed Walk Test", color: "rgba(255, 190, 118,1.0)" },
    { id: 49, name: "Distance Walk Test ", color: "rgba(255, 190, 118,1.0)"},
    { id: 50, name: "Timed Up and Go", color: "rgba(255, 190, 118,1.0)"},
    { id: 51, name: "Tandem Stance", color: "rgba(255, 190, 118,1.0)"},
    { id: 52, name: "Sit to Stand", color: "rgba(255, 190, 118,1.0)"},
  ];

  const currentActivityKey = thisSession
    ? activityKeys.find((key) => key.id === thisSession.activityID)
    : null;

  const currentActivityName = currentActivityKey?.name;

  const metricDescription = thisSession
    ? metricDescriptions.default.metrics[currentActivityName]?.sessionMetrics
    : metricDescriptions.default.metrics;

  const sessionSummary = thisSession
    ? metricDescriptions.default.metrics[currentActivityName]?.sessionSummary
    : metricDescriptions.default.metrics;

  const freeRunDescription = thisSession
    ? selectedActivityType !== null
      ? metricDescriptions.default.metrics[
          activityKeys.find(
            (item) => item.id === selectedActivityType?.activityIndex
          )?.name
        ]?.sessionMetrics
      : metricDescriptions.default.metrics[currentActivityName]?.sessionMetrics
    : metricDescriptions.default.metrics;

  const sessionScore = thisSession
    ? metricDescriptions.default.metrics[currentActivityName]?.sessionScore
    : metricDescriptions.default.metrics;

  useEffect(() => {
    if (selectedActivityType) {
      const selectedActivityForDomain = selectedActivityType.activity;

      setGraphDomain([
        selectedActivityForDomain.activityStartTime,
        selectedActivityForDomain.activityEndTime,
      ]);
    }
  }, [selectedActivityType]);

  const freeRunSummary = thisSession
    ? selectedActivityType !== null
      ? metricDescriptions.default.metrics[
          activityKeys.find(
            (item) => item.id === selectedActivityType?.activityIndex
          )?.name
        ]?.sessionSummary
      : metricDescriptions.default.metrics[currentActivityKey?.[0]?.name]
          ?.sessionSummary
    : metricDescriptions.default.metrics;

  // functions for PlayerActivityHeader

  const closeModalProtocol = () => {
    closeModal(),
      enableScrollModalClosed(),
      scrollToTop(),
      setGraphDomain(false),
      setGraphTrimDomain(["auto", "auto"]),
      setIsTrimOpen(false),
      setTeamsInOrg([]);
    setGroupsInTeams([]);
    setAthletesInTeams([]);
    sessionLoading === false ? setSessionLoading(true) : null,
      setSessionLoading(true),
      actions.resetAllData();
    actions.resetTeamAthletesData();
    actions.resetTeamGroupData();
  };

  const handleClose = () => {
    if (isClosing) return;
    setIsClosing(true);
    closeModalProtocol();
    setTimeout(() => setIsClosing(false), 500); // Allow clicks after 300ms
  };

  const gotToAthletePageProtocol = () => {
    closeModal(),
      enableScrollModalClosed(),
      scrollToTop(),
      setGraphDomain(false),
      setGraphTrimDomain(["auto", "auto"]);
  };

  //player organisation for PlayerActivityHeader component
  const playerOrganisation = organisation?.orgList.filter(
    (item) => item?.OrgID === thisSession?.orgID
  )?.[0]?.["Name"];
  const playerOrganisationIcon = organisation?.orgList.filter(
    (item) => item?.OrgID === thisSession?.orgID
  )?.[0]?.["iconURL"];

  const athleteTeam = athletesInTeams.filter(
    (item) => item.playerid === thisSession?.playerID
  );
  const athleteTeamID = athletesInTeams.filter(
    (item) => item.playerid === thisSession?.playerID
  )?.[0]?.["teamid"];
  const athleteGoupID = athletesInTeams.filter(
    (item) => item.playerid === thisSession?.playerID
  )?.[0]?.["groupid"];

  const athleteTeamName = teamsInOrg.filter(
    (item) => item.id === athleteTeamID
  )?.[0]?.["name"];
  const athleteGroupName = groupsInTeams.filter(
    (item) => item.id === athleteGoupID
  )?.[0]?.["name"];

  //athlete info object for PlayerActivityHeader component
  const playerSessionInfo = [
    {
      title: "Team",
      value: athleteTeamName ? athleteTeamName : "Unassigned",
      hasTooltip: true,
      tooltipValue: athleteTeamName
        ? athleteTeamName
        : "This Athlete has not been assigned to a team",
    },
    {
      title: "Session",
      value: selectedSessionId,
      hasTooltip: true,
      tooltipValue: `${
        sessionList?.jumpData?.data?.mv
          ? sessionList?.jumpData?.data?.mv
          : sessionList?.runData?.data?.mv
          ? sessionList?.runData?.data?.mv
          : "Rerun metrics to get metric version"
      }`,
    },
    {
      title: "Activity",
      value: activity?.[0]?.name
        ? activity[0]?.name
        : thisSession?.ActivityName,
      hasTooltip: true,
      tooltipValue: activity?.[0]?.name
        ? activity[0]?.name
        : thisSession?.ActivityName,
    },
    {
      title: "Group",
      value: athleteGroupName ? athleteGroupName : "Unassigned",
      hasTooltip: true,
      tooltipValue: athleteGroupName
        ? athleteGroupName
        : "This Athlete has not been assigned to a group",
    },
    {
      title: "Date",
      value: displayDateForPlayerList(thisSession?.tsCreated),
      hasTooltip: false,
      tooltipValue: "Tooltip",
    },
    {
      title: "Duration",
      value: msToTime(thisSession?.duration),
      hasTooltip: true,
      tooltipValue: "HH:MM:SS",
    },
  ];

  const calculateDynamicHeight = (id) => {
    const element = document.getElementById(id);
    return element ? Math.floor(element.clientHeight / 70) : 1; // Convert px to grid rows
  };

  const gridLayout = customGridLayout.map((item) => ({
    ...item,
    h: calculateDynamicHeight(item.i), // Use a function to determine height dynamically
  }));

  const succeededData = getSucceededData(sessionList);
  const hasRawData =
    succeededData?.raw && Object.keys(succeededData.raw).length;
  const hasRawDataAlt =
    succeededData?.rawData && Object.keys(succeededData.rawData).length;

  const sessionMetricTabs = [
    {
      tabName: "Summary",
    },
    {
      tabName: "Detail",
    },
  ];

  const isUploadComplete = thisSession?.md !== 0 && sessionLoading !== true;

  return (
    <TestSlide modalIn={playerActivity.graphModal} className="activity-modal">
      <div className="player-activity-box" id="modal-activity-box">
        <PlayerActivityHeader
          closeModalActions={handleClose}
          playerImageUrl={
            thisSession && thisSession.playerIconUrl
              ? thisSession.playerIconUrl
              : false
          }
          playerName={
            thisSession && thisSession.playerName
              ? thisSession.playerName
              : false
          }
          playerOrganisation={
            organisation?.orgList && thisSession?.orgID
              ? playerOrganisation
              : false
          }
          playerOrganisationIcon={
            organisation?.orgList && thisSession?.orgID
              ? playerOrganisationIcon
              : false
          }
          playerSessionInfo={playerSessionInfo}
          playerSessionDetails={thisSession?.detail || "Session Details"}
          playerSessionDetailsEditing={editForm}
          playerDetailsValue={textareaValue}
          thisSession={thisSession}
          session={session}
          selectedSessionId={selectedSessionId}
          gotToAthletePageProtocol={gotToAthletePageProtocol}
          athleteLinkTo={UserProfile_URL + "/" + thisSession?.playerID}
          sessionTags={thisSession?.tags ? JSON?.parse(thisSession?.tags) : []}
          incompleteSession={isUploadComplete}
        />
        <div className="reportsContainer" ref={containerRef}>
          <div className="is-flex is-flex-direction-column ">
            <div
              className={`buttons-container ${
                isUploadComplete ? "buttons-container-upload-incomplete" : ""
              }`}
            >
              <div className="reports_tabs">
                {sessionMetricTabs.map((item, index) => (
                  <div
                    key={`reports_tab_${item.name}_${index}`}
                    className={`reports_tab ${
                      tabSelected === index ? "reports_tab_active" : ""
                    }`}
                    onClick={() => {
                      if (tabSelected !== index) {
                        setTabSelected(index);
                      }
                    }}
                  >
                    {item.tabName}
                  </div>
                ))}
              </div>
              <div className="buttons">
                {/*--------------------------------------------------------------*/}
                {/* Commented out to add higher priority functionlaity and the code below is WIP*/}
                <MainModal
                  button={
                    <MainButton
                      buttonText={"Settings"}
                      ButtonIcon={Settings}
                      buttonBoxShadow={true}
                    />
                  }
                  modalBody={
                    <SessionSettingsModalBody
                      tableTabs={[
                        //permission based tab > nove viewable by athletes > only coaches and org admins
                        { tabName: "Metrics" },
                        { tabName: "Summary" },
                        thisUserIsAnAdminOfThisOrg(
                          organisation?.orgList?.[0]
                        ) ||
                        thisUserIsACoachOfThisOrg(organisation?.orgList?.[0])
                          ? { tabName: "Session" }
                          : null,
                      ]}
                      organisation={organisation?.orgList?.[0]}
                      user={user}
                      rerunMetricsHandler={rerunMetrics}
                      rerunMetricButtonText={rerunMetricButton}
                      discardSessionHandler={handleDiscardSessionModal}
                      currentActivity={thisSession?.ActivityName}
                      activityList={activityList?.activities}
                      sessionID={thisSession?.ID}
                      rerunMetrics={rerunMetrics}
                      sessionMetricsToggled={sessionMetricsToggled}
                      disabledGraphIDs={disabledGraphIDs}
                      setDisabledGraphIDs={setDisabledGraphIDs}
                      getGraphsRenedered={getGraphsRenedered}
                      disabledSummaryIDs={disabledSummaryIDs}
                      setDisabledSummaryIDs={setDisabledSummaryIDs}
                      getSummariesRendered={getSummariesRendered}
                      toggledSummaryIDs={toggledSummaryIDs}
                      updateSessionLayout={updateSessionLayout}
                      setCustomGridLayout={setCustomGridLayout}
                      customGridLayout={customGridLayout}
                      thisSession={thisSession}
                    />
                  }
                />
                {/*--------------------------------------------------------------*/}
                {thisSession && (
                  <div className="reports-buttons">
                    <SessionTaggingModal
                      button={
                        <MainButton
                          buttonText={"Tags"}
                          ButtonIcon={TagsIcon}
                          buttonBoxShadow={true}
                        />
                      }
                      sessionTags={JSON.parse(thisSession.tags)}
                      orgID={thisSession.orgID}
                      sessionID={thisSession.ID}
                      setTagBeingAdded={setTagBeingAdded}
                      user={props.user.id}
                    />
                  </div>
                )}
                <div className="reports-buttons">
                  <ReportsDownloadModal
                    button={
                      <MainButton
                        buttonText={"Download"}
                        ButtonIcon={DownloadIcon}
                        buttonBoxShadow={true}
                      />
                    }
                    sessionID={selectedSessionId}
                    sessionList={session?.sessionList?.data}
                  />
                </div>
              </div>
            </div>
            <div
              className={`${
                sessionLoading ? "loading-background" : "loading-finished"
              }`}
            >
              <Spinner cls="spinner" />
            </div>
            {/* end top row */}

            {thisSession &&
              thisSession.activityID === 21 &&
              !hasRawData &&
              !disabledGraphIDs.includes("Pressure_Trace") && ( //other
                <div className="metric-list-container test1">
                  {thisSession &&
                    sessionList?.runData?.data?.multimediaData?.videoURL &&
                    thisSession.activityID === 21 &&
                    !disabledGraphIDs.includes("Metric_Video") && (
                      <div
                        className={`pressure-mapping-video toggle-metric-class full-width`}
                        id="Metric_Video"
                      >
                        <Video sessionid={selectedSessionId} />
                      </div>
                    )}
                  <div
                    className="force-graph toggle-metric-class FORCE1"
                    id="Pressure_Trace"
                  >
                    <Force sessionid={selectedSessionId} showSettings={true} />
                  </div>
                </div>
              )}

            {sessionList.runData.status !== "failed" &&
              thisSession &&
              (thisSession.runTypeID > 0 || thisSession.activityTypeID === 1) &&
              tabSelected === 0 &&
              (!hasRawData || hasRawDataAlt) && (
                <div className="metric-list-container test2">
                  {sessionScore?.hasSessionScore &&
                  succeededData?.raw?.sessionScore &&
                  succeededData?.raw?.sessionScore?.[
                    sessionScore?.sessionScore?.primayScore?.primaryKey
                  ] !== null &&
                  tabSelected === 0 ? (
                    <ActivityScore
                      sessionScoreMetrics={sessionScore?.sessionScore}
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                    />
                  ) : null}
                  {sessionSummary?.hasKpiSessionSummary &&
                  !disabledGraphIDs.includes("KPI_Session_Summary") ? (
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - KPI"}
                      sessionSummaryClassName={
                        "KPI_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"KPI_Session_Summary"}
                      sessionSummaryCards={sessionSummary.kpiSessionSummary}
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      graphDomain={graphDomain}
                      hasValueToggler={true}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledKpiSummaryIDs
                      }
                    />
                  ) : null}
                  {sessionSummary?.hasAsymmetrySessionSummary &&
                  tabSelected === 0 &&
                  !disabledGraphIDs.includes("Asymmetry_Session_Summary") ? (
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - Asymmetries"}
                      sessionSummaryClassName={
                        "Asymmetry_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"Asymmetry_Session_Summary"}
                      sessionSummaryCards={
                        sessionSummary.asymmetrySessionSummary
                      }
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      graphDomain={graphDomain}
                      hasValueToggler={false}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledAsymmetrySummaryIDs
                      }
                    />
                  ) : null}
                  {sessionList.runData.data &&
                    renderCapacitanceOnly(thisSession, sessionList, "other") &&
                    tabSelected === 0 &&
                    !disabledGraphIDs.includes("Metric_Video") && (
                      <div
                        className={`pressure-mapping-video toggle-metric-class ${
                          disabledGraphIDs.includes("Foot_Phase_Images") ||
                          (Object.keys(
                            getSucceededData(sessionList)?.multimediaData || {}
                          ).length >= 6 &&
                            "full-width")
                        }`}
                        id="Metric_Video"
                      >
                        <Video sessionid={selectedSessionId} />
                      </div>
                    )}
                  {sessionList.runData.data &&
                    tabSelected === 1 &&
                    !(
                      Object.keys(
                        getSucceededData(sessionList)?.multimediaData || {}
                      ).length >= 6
                    ) &&
                    renderCapacitanceOnly(thisSession, sessionList, "other") &&
                    !disabledGraphIDs.includes("Foot_Phase_Images") && (
                      <div
                        className={`pressure-mapping-pictures toggle-metric-class metric-container-class ${
                          disabledGraphIDs.includes("Metric_Video") &&
                          "full-width"
                        }`}
                        id="Foot_Phase_Images"
                      >
                        <PictureMaps />
                      </div>
                    )}
                  {sessionList.runData.data &&
                    renderCapacitanceOnly(
                      thisSession,
                      sessionList,
                      "capacitance"
                    ) &&
                    !disabledGraphIDs.includes("Pressure_Trace") && (
                      <div
                        className="force-graph toggle-metric-class FORCE2"
                        id="Pressure_Trace"
                      >
                        <Force
                          sessionid={selectedSessionId}
                          graphDomain={graphDomain}
                          trimDomain={graphTrimDomain}
                          showSettings={true}
                          isTrimOpen={isTrimOpen}
                        />
                      </div>
                    )}

                  {getSucceededData(sessionList)?.raw &&
                  tabSelected === 1 &&
                  !Object.keys(getSucceededData(sessionList)?.raw || {})
                    .length ? (
                    <>
                      {thisSession.ActivityName === "Sprint" &&
                        sessionList.runData.data?.gaitMetricData?.driveData &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Drive_Index") && (
                          <div
                            className="to-be-added toggle-metric-class metric-container-class"
                            id="Drive_Index"
                          >
                            <DriveIndex
                              runData={sessionList.runData}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              yRange={asymRangeArray_y}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Contact_Time") && (
                          <div
                            className={`contact-time-graph toggle-metric-class metric-container-class`}
                            id="Contact_Time"
                          >
                            <GroundContactTime
                              sessionid={selectedSessionId}
                              yRange={asymRangeArray_y}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Contact_Time") && (
                          <div className="contact-time-asym">
                            <GroundContactTimeAsymmetry
                              sessionid={selectedSessionId}
                              xRange={asymRangeArray}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        activity?.[0]?.name !== "Walk" &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Flight_Time") && (
                          <div
                            className="flight-time-graph toggle-metric-class metric-container-class"
                            id="Flight_Time"
                          >
                            <FlightTime
                              match={props.match}
                              sessionid={selectedSessionId}
                              yRange={asymRangeArray_y}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        activity?.[0]?.name !== "Walk" &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Flight_Time_Asymmetry") &&
                        !disabledGraphIDs.includes("Flight_Time") && (
                          <div
                            className="flight-time-asym"
                            id="Flight_Time_Asymmetry"
                          >
                            <FlightTimeAsymmetry
                              sessionid={selectedSessionId}
                              xRange={asymRangeArray}
                              graphDomain={graphDomain}
                              thisSession={thisSession}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        sessionList.runData.data.gaitMetricData?.strideArray
                          ?.stepData &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Stride_Time") && (
                          <div
                            className="ground-clearance-graph toggle-metric-class metric-container-class"
                            id="Stride_Time"
                          >
                            <StrideTime
                              sessionid={selectedSessionId}
                              yRange={asymRangeArray_y}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        sessionList.runData.data.StrideSymmetryData?.stride &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Stride_Time_Asymmetry") &&
                        !disabledGraphIDs.includes("Stride_Time") && (
                          <div
                            className="ground-clearance-asym"
                            id="Stride_Time_Asymmetry"
                          >
                            <StrideTimeAsymmetry
                              sessionid={selectedSessionId}
                              xRange={asymRangeArray}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}

                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        sessionList.runData.data.gaitMetricData?.swingArray
                          ?.stepData &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Swing_Time") && (
                          <div
                            className="ground-clearance-graph toggle-metric-class metric-container-class"
                            id="Swing_Time"
                          >
                            <SwingTime
                              sessionid={selectedSessionId}
                              yRange={asymRangeArray_y}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        sessionList.runData.data.StrideSymmetryData?.swing &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Swing_Time_Asymmetry") &&
                        !disabledGraphIDs.includes("Swing_Time") && (
                          <div
                            className="ground-clearance-asym"
                            id="Swing_Time_Asymmetry"
                          >
                            <SwingTimeAsymmetry
                              sessionid={selectedSessionId}
                              xRange={asymRangeArray}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        sessionList.runData.data.gaitMetricData?.strideLength &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Stride_Length") && (
                          <div
                            className="ground-clearance-graph toggle-metric-class metric-container-class"
                            id="Stride_Length"
                          >
                            <StrideLength
                              sessionid={selectedSessionId}
                              yRange={asymRangeArray_y}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        sessionList.runData.data.StrideSymmetryData
                          ?.stepLength &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Step_Length_Asymmetry") &&
                        !disabledGraphIDs.includes("Step_Length") && (
                          <div
                            className="ground-clearance-asym"
                            id="Step_Length_Asymmetry"
                          >
                            <StrideLengthAsymmetry
                              sessionid={selectedSessionId}
                              xRange={asymRangeArray}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        sessionList.runData.data.gaitMetricData?.stepLength &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Step_Length") && (
                          <div
                            className="ground-clearance-graph toggle-metric-class metric-container-class"
                            id="Step_Length"
                          >
                            <StepLength
                              sessionid={selectedSessionId}
                              yRange={asymRangeArray_y}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        sessionList.runData.data.StrideSymmetryData
                          ?.stepLength &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Step_Length_Asymmetry") &&
                        !disabledGraphIDs.includes("Step_Length") && (
                          <div
                            className="ground-clearance-asym"
                            id="Step_Length_Asymmetry"
                          >
                            <StepLengthAsymmetry
                              sessionid={selectedSessionId}
                              xRange={asymRangeArray}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}

                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        (sessionList.runData.data.gaitMetricData
                          ?.meanStrideVelocity ||
                          sessionList.runData.data.gaitMetricData
                            ?.maxStrideVelocity) &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Stride_Velocity") && (
                          <div
                            className="ground-clearance-graph toggle-metric-class metric-container-class"
                            id="Stride_Velocity"
                          >
                            <StrideVelocity
                              sessionid={selectedSessionId}
                              yRange={asymRangeArray_y}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              strideVelocityDisplayed={strideVelocityDisplayed}
                              setStrideVelocityDisplayed={
                                setStrideVelocityDisplayed
                              }
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        (sessionList.runData.data.StrideSymmetryData
                          ?.meanStrideVelocity ||
                          sessionList.runData.data.StrideSymmetryData
                            ?.maxStrideVelocity) &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes(
                          "Stride_Velocity_Asymmetry"
                        ) &&
                        !disabledGraphIDs.includes("Stride_Velocity") && (
                          <div
                            className="ground-clearance-asym"
                            id="Stride_Velocity_Asymmetry"
                          >
                            <StrideVelocityAsymmetry
                              sessionid={selectedSessionId}
                              xRange={asymRangeArray}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              strideVelocityDisplayed={strideVelocityDisplayed}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes("Cadence") && (
                          <div
                            className={` estimated-steps-graph toggle-metric-class metric-container-class ${
                              disabledGraphIDs.includes(
                                "Peak_Tibial_Acceleration"
                              ) && "full-width"
                            }`}
                            id="Cadence"
                          >
                            <CadenceReport
                              cadenceFrequencyToggler={cadenceFrequencyToggler}
                              setCadenceFrequencyToggler={
                                setCadenceFrequencyToggler
                              }
                              sessionid={selectedSessionId}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes(
                          "Peak_Tibial_Acceleration"
                        ) && (
                          <div
                            className={`peak-tibial-acceleration-graph toggle-metric-class metric-container-class ${
                              disabledGraphIDs.includes("Cadence") &&
                              "full-width"
                            }`}
                            id="Peak_Tibial_Acceleration"
                          >
                            <PeakTibialAcceleration
                              sessionid={selectedSessionId}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                              isTrimOpen={isTrimOpen}
                            />
                          </div>
                        )}
                      {sessionList.runData.data &&
                        tabSelected === 1 &&
                        playerActivity.graphModal &&
                        renderCapacitanceOnly(
                          thisSession,
                          sessionList,
                          "other"
                        ) &&
                        !disabledGraphIDs.includes(
                          "Swing_Stance_Footstrike"
                        ) && (
                          <div
                            className="swing-stance-foot-strike toggle-metric-class metric-container-class"
                            id="Swing_Stance_Footstrike"
                          >
                            {/* <FootstrikeReport sessionid={sessionId} /> */}
                            <SwingStanceFootStrike />
                          </div>
                        )}
                    </>
                  ) : null}
                </div>
              )}
            {sessionList.rawData.status !== "failed" &&
              thisSession &&
              thisSession.activityTypeID === 5 &&
              tabSelected === 0 &&
              !hasRawData &&
              !hasRawDataAlt && (
                <div className="metric-list-container test3">
                  {sessionScore?.hasSessionScore &&
                  succeededData?.raw?.sessionScore &&
                  succeededData?.raw?.sessionScore?.[
                    sessionScore?.sessionScore?.primayScore?.primaryKey
                  ] !== null &&
                  tabSelected === 0 ? (
                    <ActivityScore
                      sessionScoreMetrics={sessionScore?.sessionScore}
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                    />
                  ) : null}

                  {sessionSummary?.hasKpiSessionSummary &&
                  !disabledGraphIDs.includes("KPI_Session_Summary") ? (
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - KPI"}
                      sessionSummaryClassName={
                        "KPI_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"KPI_Session_Summary"}
                      sessionSummaryCards={sessionSummary.kpiSessionSummary}
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      hasValueToggler={true}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledKpiSummaryIDs
                      }
                    />
                  ) : null}
                  {sessionSummary?.hasAsymmetrySessionSummary &&
                  tabSelected === 0 &&
                  !disabledGraphIDs.includes("Asymmetry_Session_Summary") ? (
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - Asymmetries"}
                      sessionSummaryClassName={
                        "Asymmetry_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"Asymmetry_Session_Summary"}
                      sessionSummaryCards={
                        sessionSummary.asymmetrySessionSummary
                      }
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      hasValueToggler={false}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledAsymmetrySummaryIDs
                      }
                    />
                  ) : null}
                  {sessionList?.rawData?.data?.multimediaData?.videoURL &&
                    tabSelected === 0 &&
                    !disabledGraphIDs.includes("Metric_Video") && (
                      <div
                        className={`pressure-mapping-video toggle-metric-class ${"full-width"}`}
                        id="Metric_Video"
                      >
                        <Video sessionid={selectedSessionId}></Video>
                      </div>
                    )}
                  {sessionList.rawData.data &&
                    renderCapacitanceOnly(
                      thisSession,
                      sessionList,
                      "capacitance"
                    ) &&
                    !disabledGraphIDs.includes("Pressure_Trace") && (
                      <div
                        className="force-graph toggle-metric-class FORCE3"
                        id="Pressure_Trace"
                      >
                        <Force
                          sessionid={selectedSessionId}
                          graphDomain={graphDomain}
                          trimDomain={graphTrimDomain}
                          showSettings={true}
                          isTrimOpen={isTrimOpen}
                        />
                      </div>
                    )}
                </div>
              )}
            {thisSession &&
              (thisSession.jumpTypeID > 0 ||
                thisSession.activityTypeID === 2) &&
              thisSession.jumpTypeID != 19 &&
              tabSelected === 0 &&
              !hasRawData && ( //19 == Isometric Calf  Test
                <div className="metric-list-container test4">
                  {sessionScore?.hasSessionScore &&
                  succeededData?.raw?.sessionScore &&
                  succeededData?.raw?.sessionScore?.[
                    sessionScore?.sessionScore?.primayScore?.primaryKey
                  ] !== null &&
                  tabSelected === 0 ? (
                    <ActivityScore
                      sessionScoreMetrics={sessionScore?.sessionScore}
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                    />
                  ) : null}
                  {sessionSummary?.hasKpiSessionSummary &&
                  !disabledGraphIDs.includes("KPI_Session_Summary") ? (
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - KPI"}
                      sessionSummaryClassName={
                        "KPI_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"KPI_Session_Summary"}
                      sessionSummaryCards={sessionSummary.kpiSessionSummary}
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      hasValueToggler={true}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledKpiSummaryIDs
                      }
                    />
                  ) : null}
                  {sessionSummary?.hasAsymmetrySessionSummary &&
                  tabSelected === 0 &&
                  !disabledGraphIDs.includes("Asymmetry_Session_Summary") ? (
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - Asymmetries"}
                      sessionSummaryClassName={
                        "Asymmetry_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"Asymmetry_Session_Summary"}
                      sessionSummaryCards={
                        sessionSummary.asymmetrySessionSummary
                      }
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      hasValueToggler={false}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledAsymmetrySummaryIDs
                      }
                    />
                  ) : null}
                  {!disabledGraphIDs.includes("Metric_Video") &&
                    tabSelected === 0 && (
                      <div
                        className={`pressure-mapping-video toggle-metric-class ${
                          disabledGraphIDs.includes("Foot_Phase_Images") ||
                          (Object.keys(
                            getSucceededData(sessionList)?.multimediaData || {}
                          ).length >= 6 &&
                            "full-width")
                        }`}
                        id="Metric_Video"
                      >
                        <Video sessionid={selectedSessionId}></Video>
                      </div>
                    )}
                  {!disabledGraphIDs.includes("Foot_Phase_Images") &&
                    tabSelected === 1 &&
                    !(
                      Object.keys(
                        getSucceededData(sessionList)?.multimediaData || {}
                      ).length >= 6
                    ) && (
                      <div
                        className={`pressure-mapping-pictures toggle-metric-class metric-container-class ${
                          disabledGraphIDs.includes("Metric_Video") &&
                          "full-width"
                        }`}
                        id="Foot_Phase_Images"
                      >
                        <PictureMaps />
                      </div>
                    )}
                  {!disabledGraphIDs.includes("Pressure_Trace") && (
                    <div
                      className="force-graph toggle-metric-class FORCE4"
                      id="Pressure_Trace"
                    >
                      <Force
                        sessionid={selectedSessionId}
                        displayTotal={true}
                        trimDomain={graphTrimDomain}
                        graphDomain={graphDomain}
                        showSettings={true}
                      />
                    </div>
                  )}

                  {getSucceededData(sessionList)?.raw &&
                  tabSelected === 1 &&
                  !Object.keys(getSucceededData(sessionList)?.raw || {})
                    .length ? (
                    <>
                      {metricRules.DisplayRSI(
                        thisSession.jumpTypeID,
                        thisSession.activityID
                      ) &&
                        !disabledGraphIDs.includes("RSI") && (
                          <div
                            className="rsi-graph toggle-metric-class metric-container-class"
                            id="RSI"
                          >
                            <RSI
                              sessionid={selectedSessionId}
                              xRange={asymJumpRangeArray}
                              graphDomain={graphDomain}
                              showSettings={true}
                            />
                          </div>
                        )}

                      {metricRules.DisplayJumpHeight(
                        thisSession.jumpTypeID,
                        thisSession.activityID
                      ) &&
                        tabSelected === 1 &&
                        !disabledGraphIDs.includes("Jump_Height") && (
                          <div
                            className="jump-height-graph toggle-metric-class metric-container-class"
                            id="Jump_Height"
                          >
                            <JumpHeight
                              sessionid={selectedSessionId}
                              xRange={asymJumpRangeArray}
                              graphDomain={graphDomain}
                              showSettings={true}
                            />
                          </div>
                        )}
                      {metricRules.DisplayFlightTimeJump(
                        thisSession.jumpTypeID,
                        thisSession.activityID
                      ) &&
                        tabSelected === 1 &&
                        !disabledGraphIDs.includes("Flight_Time") && (
                          <div
                            className="flight-time-jump-graph toggle-metric-class metric-container-class"
                            id="Flight_Time"
                          >
                            <FlightTimeJump
                              thisSession={thisSession}
                              sessionid={selectedSessionId}
                              xRange={asymJumpRangeArray}
                              graphDomain={graphDomain}
                              showSettings={true}
                            />
                          </div>
                        )}
                      {metricRules.DisplayJumpLength(
                        thisSession.activityTypeID,
                        thisSession.activityID
                      ) &&
                        tabSelected === 1 &&
                        !disabledGraphIDs.includes("Jump_Length") && (
                          <div
                            className="jump-length-graph toggle-metric-class metric-container-class"
                            id="Jump_Length"
                          >
                            <JumpLength
                              sessionid={selectedSessionId}
                              yRange={asymRangeArray_y}
                              graphDomain={graphDomain}
                              trimDomain={graphTrimDomain}
                              showSettings={true}
                            />
                          </div>
                        )}
                      {metricRules.DisplayJumpVelocity(
                        thisSession.activityTypeID,
                        thisSession.activityID
                      ) &&
                        tabSelected === 1 &&
                        !disabledGraphIDs.includes("Jump_Velocity") && (
                          <div
                            className="jump-velocity-graph toggle-metric-class metric-container-class"
                            id="Jump_Velocity"
                          >
                            <JumpVelocity
                              sessionid={selectedSessionId}
                              yRange={asymRangeArray_y}
                              showSettings={true}
                              jumpVelocityDisplayed={jumpVelocityDisplayed}
                              setJumpVelocityDisplayed={
                                setJumpVelocityDisplayed
                              }
                            />
                          </div>
                        )}
                      {metricRules.DisplayContactTimeJump(
                        thisSession.jumpTypeID,
                        thisSession.activityID
                      ) &&
                        tabSelected === 1 &&
                        !disabledGraphIDs.includes("Contact_Time") && (
                          <div
                            className="contact-time-jump-graph toggle-metric-class metric-container-class"
                            id="Contact_Time"
                          >
                            <ContactTimeJump
                              sessionid={selectedSessionId}
                              xRange={asymJumpRangeArray}
                              graphDomain={graphDomain}
                              showSettings={true}
                            />
                          </div>
                        )}
                      {metricRules.DisplayPower(
                        thisSession.jumpTypeID,
                        thisSession.activityID
                      ) &&
                        tabSelected === 1 &&
                        !disabledGraphIDs.includes("Peak_Power") && (
                          <div
                            className="jump-power-graph toggle-metric-class metric-container-class"
                            id="Peak_Power"
                          >
                            <Power
                              sessionid={selectedSessionId}
                              xRange={asymJumpRangeArray}
                              graphDomain={graphDomain}
                              showSettings={true}
                            />
                          </div>
                        )}
                    </>
                  ) : null}
                </div>
              )}
            {/* ------------------------------------------------------------------------------------ */}
            {/* ------------------------------------------------------------------------------------ */}
            {/* ------------------------------------------------------------------------------------ */}

            {thisSession && thisSession.activityID !== 46 ? (
              // <ResponsiveGridLayout
              //   className={"metric-list-container"}
              //   breakpoints={{ lg: 0 }}
              //   cols={{ lg: 1 }}
              //   rowHeight={70}
              //   isResizable={false}
              //   isRearrangeable={false}
              //   isDraggable={false}
              //   layouts={{ lg: gridLayout }}
              //   onLayoutChange={(e) => {
              //     handleLayoutChange(e);
              //   }}
              //   autoSize={true}
              // >
              <div className="metric-list-container metric-list-container-freerun">
                {/* --------------------------------------------------------------*/}

                {sessionScore?.hasSessionScore &&
                sessionScore?.hasSessionScore &&
                succeededData?.raw?.sessionScore &&
                succeededData?.raw?.sessionScore?.[
                  sessionScore?.sessionScore?.primayScore?.primaryKey
                ] !== null &&
                tabSelected === 0 ? (
                  <ActivityScore
                    sessionScoreMetrics={sessionScore?.sessionScore}
                    sessionData={sessionList}
                    getSucceededData={getSucceededData}
                  />
                ) : null}

                {(hasRawData || hasRawDataAlt) &&
                sessionSummary?.hasKpiSessionSummary &&
                tabSelected === 0 &&
                !disabledGraphIDs.includes("KPI_Session_Summary") ? (
                  <div key={"KPI_Session_Summary"}>
                    {" "}
                    {/* class id and key in here causes render cannot render */}
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - KPI"}
                      sessionSummaryClassName={
                        "KPI_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"KPI_Session_Summary"}
                      sessionSummaryCards={sessionSummary.kpiSessionSummary}
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      graphDomain={graphDomain}
                      hasValueToggler={true}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledKpiSummaryIDs
                      }
                    />
                  </div>
                ) : null}

                {(hasRawData || hasRawDataAlt) &&
                sessionSummary?.hasAsymmetrySessionSummary &&
                tabSelected === 0 &&
                !disabledGraphIDs.includes("Asymmetry_Session_Summary") ? (
                  <div key={"Asymmetry_Session_Summary"}>
                    {" "}
                    {/* class id and key in here causes render cannot render */}
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - Asymmetries"}
                      sessionSummaryClassName={
                        "Asymmetry_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"Asymmetry_Session_Summary"}
                      sessionSummaryCards={
                        sessionSummary.asymmetrySessionSummary
                      }
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      graphDomain={graphDomain}
                      hasValueToggler={false}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledAsymmetrySummaryIDs
                      }
                    />
                  </div>
                ) : null}

                {(hasRawData || hasRawDataAlt) &&
                  !disabledGraphIDs.includes("Metric_Video") &&
                  tabSelected === 0 && (
                    <div
                      className={`pressure-mapping-video toggle-metric-class full-width`}
                      id="Metric_Video"
                      key="Metric_Video"
                    >
                      <Video sessionid={selectedSessionId}></Video>
                    </div>
                  )}

                {(hasRawData || hasRawDataAlt) &&
                  !disabledGraphIDs.includes("Pressure_Trace") && (
                    <div
                      className="force-graph toggle-metric-class FORCE5"
                      id="Pressure_Trace"
                      key="Pressure_Trace"
                    >
                      <Force
                        sessionid={selectedSessionId}
                        displayTotal={true}
                        trimDomain={graphTrimDomain}
                        graphDomain={graphDomain}
                        showSettings={true}
                      />
                    </div>
                  )}

                {thisSession &&
                  (tabSelected === 1 ||
                    currentActivityKey?.id === 41 ||
                    currentActivityKey?.id === 42 ||
                    currentActivityKey?.id === 51 ) &&
                  metricDescription &&
                  (() => {
                    return (
                      (hasRawData || hasRawDataAlt) &&
                      metricDescription.map((metric, index) => (
                        <div key={`${metric.MetricID}`}>
                          <RawChartComponent
                            key={`rawMetric${index}`}
                            metric={metric}
                            sessionMetricData={sessionList}
                            metricPrimaryGraphName={metric.MetricTitle}
                            metricID={metric.MetricID}
                            metricSecondaryGraphName={
                              metric.SecondaryMetricTitle
                            }
                            metricPrimaryKey={metric.MetricMainKey}
                            metricSecondaryKey={metric.SecondaryMainKey}
                            metricTertiaryKey={metric.TertiaryMainKey}
                            metricPrimaryName={metric.MetricTitle}
                            metricSecondaryName={metric.SecondaryMetricTitle}
                            metricUnit={metric.MetricUnit}
                            metricSecondaryUnit={metric.SecondaryMetricUnit}
                            metricPrimaryDescription={metric.MetricDescription}
                            metricSecondaryDescription={
                              metric.SecondaryMetricDescription
                            }
                            metricChartType={metric.chartType}
                            toggleableMetric={metric.togglable}
                            toggleOptions={metric.toggleOptions}
                            xAxisValue={metric.xAxisValue}
                            xAxisSecondaryValue={metric.SecondaryxAxisValue}
                            xAxisLabel={metric.xAxisLabel}
                            xAxisSecondaryLabel={metric.xAxisSecondaryLabel}
                            yAxisLabel={metric.yAxisLabel}
                            yAxisSecondaryLabel={metric.yAxisSecondaryLabel}
                            inDevelopment={metric.inDevelopment}
                            bilateral={metric.bilateral}
                            hasBilateralToggler={metric.hasBilateralToggler}
                            bilateralToggleOptions={
                              metric.bilateralToggleOptions
                            }
                            hasBilateralAsymmetry={metric.hasBilateralAsymmetry}
                            bilateralAsymmetryKeys={
                              metric.bilateralAsymmetryKeys
                            }
                            hasCombinedKeys={metric.hasCombinedKeys}
                            mainDataKeys={metric.mainDataKeys}
                            combinedMainKeys={metric.combinedMainKeys}
                            combinedDataKeys={metric.combinedDataKeys}
                            hasAsymmetry={metric.hasAsymmetry}
                            asymmetryDataKeys={metric.asymmetryDataKeys}
                            forDevOnly={metric.devOnly}
                            secondaryDataKeys={metric.secondaryDataKeys}
                            graphDomain={
                              metric.chartType !== "image" ? graphDomain : null
                            }
                            trimDomain={
                              metric.chartType !== "image"
                                ? graphTrimDomain
                                : null
                            }
                            isTrimOpen={isTrimOpen}
                            metricName={metric.MetricName}
                            metricSecondaryMetricName={
                              metric.SecondaryMetricName
                            }
                            metricTertiaryMetricName={metric.TertiaryMetricName}
                            isJump={metric.isJump}
                            isSuperAdmin={props.user.permissionLevel === 1}
                            getSucceededData={getSucceededData}
                            hasCards={metric.hasCards}
                            cardKeys={metric.cardKeys}
                            cardHeadings={metric.cardHeadings}
                            cardUnits={metric.cardUnits}
                            imageHeadings={metric.imageHeadings}
                            imageDataKeys={metric.imageDataKeys}
                            imageTooltips={metric.imageTooltips}
                            disabledGraphIDs={disabledGraphIDs}
                          />
                        </div>
                      ))
                    );
                  })()}
              </div>
            ) : // </ResponsiveGridLayout>
            null}

            {/* This section below is used for activity classification and swapping between activities functionality */}
            {thisSession && thisSession.activityID === 46 ? (
              // <ResponsiveGridLayout
              //   className={"metric-list-container"}
              //   breakpoints={{ lg: 0 }}
              //   cols={{ lg: 1 }}
              //   rowHeight={70}
              //   isResizable={false}
              //   isRearrangeable={false}
              //   isDraggable={false}
              //   layouts={{ lg: gridLayout }}
              //   onLayoutChange={(e) => {
              //     handleLayoutChange(e);
              //   }}
              //   autoSize={true}
              // >
              <div
                className={
                  "metric-list-container metric-list-container-freerun"
                }
              >
                {sessionScore?.hasSessionScore &&
                succeededData?.raw?.sessionScore &&
                succeededData?.raw?.sessionScore?.[
                  sessionScore?.sessionScore?.primayScore?.primaryKey
                ] !== null &&
                tabSelected === 0 ? (
                  <ActivityScore
                    sessionScoreMetrics={sessionScore?.sessionScore}
                    sessionData={sessionList}
                    getSucceededData={getSucceededData}
                  />
                ) : null}

                {(hasRawData || hasRawDataAlt) &&
                  !disabledGraphIDs.includes("Pressure_Trace") && (
                    <div
                      className="force-graph toggle-metric-class FORCE6"
                      id="Pressure_Trace"
                      key="Pressure_Trace"
                    >
                      <Force
                        hasMultipleActivities={
                          succeededData?.raw?.activityClassification
                        }
                        sessionid={selectedSessionId}
                        displayTotal={true}
                        trimDomain={graphTrimDomain}
                        graphDomain={graphDomain}
                        setGraphDomain={setGraphDomain}
                        showSettings={true}
                        setSelectedActivityType={setSelectedActivityType}
                        selectedActivityType={selectedActivityType}
                        activityKeys={activityKeys}
                      />
                    </div>
                  )}

                {selectedActivityType ? (
                  <div className="activity-classification-selected-heading">
                    <h3>
                      {
                        activityKeys.filter(
                          (item) =>
                            item.id === selectedActivityType?.activityIndex
                        )?.[0]?.["name"]
                      }
                    </h3>
                  </div>
                ) : null}

                {(hasRawData || hasRawDataAlt) &&
                freeRunSummary?.hasKpiSessionSummary &&
                tabSelected === 0 &&
                !disabledGraphIDs.includes("KPI_Session_Summary") ? (
                  <div key={"KPI_Session_Summary"}>
                    {" "}
                    {/* class id and key in here causes render cannot render */}
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - KPI"}
                      sessionSummaryClassName={
                        "KPI_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"KPI_Session_Summary"}
                      sessionSummaryCards={freeRunSummary.kpiSessionSummary}
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      graphDomain={graphDomain}
                      hasValueToggler={true}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledKpiSummaryIDs
                      }
                      selectedActivityType={selectedActivityType}
                    />
                  </div>
                ) : null}

                {(hasRawData || hasRawDataAlt) &&
                freeRunSummary?.hasAsymmetrySessionSummary &&
                tabSelected === 0 &&
                !disabledGraphIDs.includes("Asymmetry_Session_Summary") ? (
                  <div key={"Asymmetry_Session_Summary"}>
                    <SessionSummary
                      summaryMetricTitle={"Session Summary - Asymmetries"}
                      sessionSummaryClassName={
                        "Asymmetry_Session_Summary toggle-metric-class metric-container-class"
                      }
                      sessionSummaryID={"Asymmetry_Session_Summary"}
                      sessionSummaryCards={
                        freeRunSummary.asymmetrySessionSummary
                      }
                      sessionData={sessionList}
                      getSucceededData={getSucceededData}
                      graphDomain={graphDomain}
                      hasValueToggler={false}
                      disabledSummaryIDs={
                        disabledSummaryIDs.disabledAsymmetrySummaryIDs
                      }
                      selectedActivityType={selectedActivityType}
                    />
                  </div>
                ) : null}

                {thisSession &&
                  freeRunDescription &&
                  (tabSelected === 1 ||
                    currentActivityKey?.id === 41 ||
                    currentActivityKey?.id === 42 ||
                    currentActivityKey?.id === 51) &&
                  (() => {
                    const shouldRenderCharts = hasRawData || hasRawDataAlt;
                    const hasActivityClassification =
                      succeededData?.raw?.activityClassification;

                    const renderRawCharts = () =>
                      freeRunDescription.map((metric, index) => (
                        <div key={metric.MetricID}>
                          <RawChartComponent
                            key={`rawMetric${index}`}
                            metric={metric}
                            sessionMetricData={sessionList}
                            metricPrimaryGraphName={metric.MetricTitle}
                            metricID={metric.MetricID}
                            metricSecondaryGraphName={
                              metric.SecondaryMetricTitle
                            }
                            metricPrimaryKey={metric.MetricMainKey}
                            metricSecondaryKey={metric.SecondaryMainKey}
                            metricTertiaryKey={metric.TertiaryMainKey}
                            metricPrimaryName={metric.MetricTitle}
                            metricSecondaryName={metric.SecondaryMetricTitle}
                            metricUnit={metric.MetricUnit}
                            metricSecondaryUnit={metric.SecondaryMetricUnit}
                            metricPrimaryDescription={metric.MetricDescription}
                            metricSecondaryDescription={
                              metric.SecondaryMetricDescription
                            }
                            metricChartType={metric.chartType}
                            toggleableMetric={metric.togglable}
                            toggleOptions={metric.toggleOptions}
                            xAxisValue={metric.xAxisValue}
                            xAxisSecondaryValue={metric.SecondaryxAxisValue}
                            xAxisLabel={metric.xAxisLabel}
                            xAxisSecondaryLabel={metric.xAxisSecondaryLabel}
                            yAxisLabel={metric.yAxisLabel}
                            yAxisSecondaryLabel={metric.yAxisSecondaryLabel}
                            inDevelopment={metric.inDevelopment}
                            bilateral={metric.bilateral}
                            hasBilateralToggler={metric.hasBilateralToggler}
                            bilateralToggleOptions={
                              metric.bilateralToggleOptions
                            }
                            hasBilateralAsymmetry={metric.hasBilateralAsymmetry}
                            bilateralAsymmetryKeys={
                              metric.bilateralAsymmetryKeys
                            }
                            hasCombinedKeys={metric.hasCombinedKeys}
                            mainDataKeys={metric.mainDataKeys}
                            combinedMainKeys={metric.combinedMainKeys}
                            combinedDataKeys={metric.combinedDataKeys}
                            hasAsymmetry={metric.hasAsymmetry}
                            asymmetryDataKeys={metric.asymmetryDataKeys}
                            forDevOnly={metric.devOnly}
                            secondaryDataKeys={metric.secondaryDataKeys}
                            graphDomain={
                              metric.chartType !== "image" ? graphDomain : null
                            }
                            trimDomain={
                              metric.chartType !== "image"
                                ? graphTrimDomain
                                : null
                            }
                            isTrimOpen={isTrimOpen}
                            metricName={metric.MetricName}
                            metricSecondaryMetricName={
                              metric.SecondaryMetricName
                            }
                            metricTertiaryMetricName={metric.TertiaryMetricName}
                            isJump={metric.isJump}
                            isSuperAdmin={props.user.permissionLevel === 1}
                            getSucceededData={getSucceededData}
                            hasCards={metric.hasCards}
                            cardKeys={metric.cardKeys}
                            cardHeadings={metric.cardHeadings}
                            cardUnits={metric.cardUnits}
                            imageHeadings={metric.imageHeadings}
                            imageDataKeys={metric.imageDataKeys}
                            imageTooltips={metric.imageTooltips}
                            disabledGraphIDs={disabledGraphIDs}
                            selectedActivityType={
                              selectedActivityType?.activityIndex ?? false
                            }
                            hasMultipleActivities={
                              selectedActivityType && hasActivityClassification
                                ? succeededData.raw.activityClassification.some(
                                    (key) =>
                                      key.activityLabel ===
                                      activityKeys
                                        .find(
                                          (item) =>
                                            item.id ===
                                            selectedActivityType.activityIndex
                                        )
                                        ?.name.toLowerCase()
                                        .replace(/\s/g, "")
                                  )
                                : false
                            }
                          />
                        </div>
                      ));

                    if (hasActivityClassification && selectedActivityType) {
                      return shouldRenderCharts ? renderRawCharts() : null;
                    }

                    if (!hasActivityClassification) {
                      return shouldRenderCharts ? renderRawCharts() : null;
                    }
                  })()}
              </div>
            ) : // </ResponsiveGridLayout>
            null}

            {/* ------------------------------------------------------------------------------------ */}
            {/* ------------------------------------------------------------------------------------ */}
            {/* ------------------------------------------------------------------------------------ */}
            {/* ------------------------------------------------------------------------------------ */}

            {thisSession &&
              !succeededData?.raw?.activityClassification &&
              (thisSession.runTypeID > 0 ||
                thisSession.activityTypeID === 1) && (
                <div className="metric-brush-container-closed">
                  <div
                    className="testButton"
                    onClick={() => handleBrushResize()}
                  >
                    <div className="brush-arrow">
                      <MagnifyingGlass direction={"up"} />
                    </div>
                  </div>
                  <div className="brush-container">
                    <MetricBrush
                      setGraphDomain={setGraphDomain}
                      resetBrush={domainToggle}
                      trimDomain={
                        graphTrimDomain[0] !== "auto" ? graphTrimDomain : false
                      }
                    />
                    <div className="brush-options">
                      <div
                        onClick={() => {
                          setGraphDomain(
                            graphTrimDomain[0] !== "auto"
                              ? graphTrimDomain
                              : false
                          );
                          setDomainToggle(!domainToggle);
                        }}
                      >
                        <MainButton
                          buttonText={"Clear Zoom"}
                          buttonPop={true}
                          buttonBoxShadow={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {thisSession &&
              succeededData?.raw?.activityClassification &&
              thisSession.activityID === 46 &&
              !selectedActivityType &&
              (thisSession.runTypeID > 0 ||
                thisSession.activityTypeID === 1) && (
                <div className="metric-brush-container-closed">
                  <div
                    className="testButton"
                    onClick={() => handleBrushResize()}
                  >
                    <div className="brush-arrow">
                      <MagnifyingGlass direction={"up"} />
                    </div>
                  </div>
                  <div className="brush-container">
                    <MetricBrush
                      setGraphDomain={setGraphDomain}
                      resetBrush={domainToggle}
                      trimDomain={
                        graphTrimDomain[0] !== "auto" ? graphTrimDomain : false
                      }
                    />
                    <div className="brush-options">
                      <div
                        onClick={() => {
                          setGraphDomain(
                            graphTrimDomain[0] !== "auto"
                              ? graphTrimDomain
                              : false
                          );
                          setDomainToggle(!domainToggle);
                        }}
                      >
                        <MainButton
                          buttonText={"Clear Zoom"}
                          buttonPop={true}
                          buttonBoxShadow={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {thisSession &&
              !succeededData?.raw?.activityClassification &&
              (thisSession.runTypeID > 0 ||
                thisSession.activityTypeID === 1) && (
                <div className="metric-trim-brush-container-closed">
                  <div className="testButton" onClick={() => handleBrushTrim()}>
                    <div className="brush-arrow">
                      <TrimIcon
                        size="17px"
                        fill={graphDomain ? "#49afc8" : "#ffffff"}
                      />
                    </div>
                  </div>
                  <div className="brush-container">
                    <MetricTrimBrush
                      setGraphTrim={setGraphTrimDomain}
                      //graphDomain={graphTrimDomain[0] !== "auto" ? graphTrimDomain :  false}
                    />
                    <div className="trim-options">
                      <div
                        onClick={async () => {
                          const postBody = [
                            {
                              from: graphTrimDomain[0] * 1000,
                              to: graphTrimDomain[1] * 1000,
                            },
                          ];
                          const setSessionTrimCheck = await setSessionTrim(
                            thisSession.ID,
                            postBody
                          );

                          if (setSessionTrimCheck.data === true) {
                            if ((await thisSession.ActivityType) === "Jump") {
                              await actions.resetJumpData(thisSession.ID);
                              setTrimToggle(!trimToggle);
                              updatedData = await getJumpDataAPI(
                                thisSession.ID
                              );
                              let domainStart =
                                (await updatedData.td[0].from) / 1000;
                              let domainEnd =
                                (await updatedData.td[0].to) / 1000;
                              setGraphDomain([domainStart, domainEnd]);
                              handleBrushTrim();
                            }

                            if ((await thisSession.ActivityType) === "Run") {
                              await actions.resetRunData(thisSession.ID);
                              setTrimToggle(!trimToggle);
                              updatedData = await getRunDataAPI(thisSession.ID);
                              let domainStart =
                                (await updatedData.td[0].from) / 1000;
                              let domainEnd =
                                (await updatedData.td[0].to) / 1000;
                              setGraphDomain([domainStart, domainEnd]);
                              handleBrushTrim();
                            }
                          }
                        }}
                      >
                        <MainButton
                          buttonText={"Confirm Trim"}
                          buttonPop={true}
                          buttonBoxShadow={true}
                        />
                      </div>
                      <div
                        onClick={async () => {
                          await resetSessionTrim(thisSession.ID);
                          setTrimToggle(!trimToggle);
                          setGraphTrimDomain(false);
                          setGraphDomain(false);
                          checkForJumpData();
                        }}
                      >
                        <MainButton
                          buttonText={"Clear Trim"}
                          buttonPop={true}
                          buttonBoxShadow={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {thisSession &&
              succeededData?.raw?.activityClassification &&
              thisSession.activityID === 46 &&
              selectedActivityType &&
              (thisSession.runTypeID > 0 ||
                thisSession.activityTypeID === 1) && (
                <div className="metric-trim-brush-container-closed">
                  <div
                    className={`testButton ${
                      selectedActivityType ? "clear_activity_active" : ""
                    }`}
                    onClick={() => {
                      setSelectedActivityType(null),
                        setGraphDomain(false),
                        scrollToTop(containerRef);
                    }}
                  >
                    <div className="brush-arrow">
                      <EscapeIcon />
                    </div>
                  </div>
                </div>
              )}

            {/*
              "MetricMainKey": "maxStrideVelocity",
              "SecondaryMainKey": "meanStrideVelocity",
              "MetricName": "Maximum Stride Velocity",
              "SecondaryMetricName": "Mean Stride Velocity",
              "MetricUnit": "m/s",
              "MetricDescription": "Maximum velocity recorded above the ankle during each step.",
              "SecondaryMetricDescription": "The average velocity recorded above the ankle during each step",
              "MetricTitle": "Maximum Stride Velocity (m/s)",
              "SecondaryMetricTitle": "Mean Stride Velocity (m/s)",
              "xAxisValue": "timeOfStep",
              "xAxisLabel": "Time (s)",
              "yAxisLabel": "Velocity (m/s)",
              "chartType": "line",
              "togglable": true
            */}
          </div>
        </div>
      </div>
      {
        ///discard session modal
        <AlertDialogDemo
          type="discardSession"
          open={discardSessionModalOpen}
          proceed={discardSession}
          setDiscardSessionModalOpen={setDiscardSessionModalOpen}
        />
      }
    </TestSlide>
  );
}

const mapStateToProps = (state) => {
  return {
    user: selectUser(state),
    organisation: selectOrganisation(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getSessionList,
      getupdateSessionDetail,
      getJumpData,
      getRunData,
      resetJumpData,
      resetRunData,
      resetAllData,
      resetTeamGroupData,
      resetTeamAthletesData,
    },
    dispatch
  ),
});

export default React.memo(
  connect(mapStateToProps, mapDispatchToProps)(PlayerActivityDetails)
);
